import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

import * as S from './styled';

import { LayoutProps } from '../types';

const CompanionModeLayout = ({ children, titleKey }: LayoutProps) => {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = t(titleKey);
    }, [t, titleKey]);

    return (
        <S.BodyContainer isBlack>
            <S.MainContainer>{children}</S.MainContainer>
        </S.BodyContainer>
    );
};

export default CompanionModeLayout;
